module.exports = __webpack_public_path__ + "static/img/s3.3a93d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s3.png
// module id = nVUS
// module chunks = 0